'use client';

import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import { useIntl } from 'react-intl';
import { SuccessPage } from '../SuccessPage.client';
import type { NewsletterSubscribePageProps } from '../types';
import IconNlSubscribe3Successful from './animated/IconNlSubscribe3Successful';
import { pagesMessages } from './helpers/messages';

export const Page4KnownUser = ({
  headline,
  text,
  buttonLabel,
  buttonLabelMobile,
}: NewsletterSubscribePageProps) => {
  const intl = useIntl();
  const { isMobile } = useDeviceType();

  const customButtonLabel = isMobile ? buttonLabelMobile : buttonLabel;
  const finalButtonLabel = customButtonLabel ?? intl.formatMessage(pagesMessages.page4.button);

  return (
    <SuccessPage
      icon={<IconNlSubscribe3Successful className="mx-auto my-0 mb-3 h-[8rem]" />}
      headline={headline ?? intl.formatMessage(pagesMessages.page4.headline)}
      description={text ?? intl.formatMessage(pagesMessages.page4.description)}
      button={{ text: finalButtonLabel, primary: true }}
    />
  );
};
